import React from 'react'
import { Link } from 'react-router-dom'
import { PlusIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import { useLanguage } from '../../contexts/LanguageContext'
import { CATALOG_SERVICE_SLUGS } from '../../config/serviceCatalog'

export default function ServicesNavDropdown({ onLinkClick, className = '', embedded = false }) {
  const { t } = useLanguage()

  return (
    <div className={clsx(embedded ? '' : 'mv-pillars-band--menu overflow-hidden rounded-none shadow-[0_16px_48px_-8px_rgba(10,25,47,0.55),0_8px_24px_-6px_rgba(16,34,64,0.45)]', className)}>
      <ul
        className={clsx(
          'grid grid-cols-1 divide-y divide-white/10',
          embedded
            ? ''
            : 'sm:grid-cols-2 sm:divide-y-0 sm:[&>li:nth-child(odd)]:border-r sm:[&>li:nth-child(odd)]:border-white/10 lg:grid-cols-3 lg:[&>li:nth-child(odd)]:border-r-0 lg:[&>li:not(:nth-child(3n))]:border-r lg:[&>li:not(:nth-child(3n))]:border-white/10'
        )}
      >
        {CATALOG_SERVICE_SLUGS.map((slug, i) => (
          <li
            key={slug}
            className={embedded ? '' : i >= 1 ? 'sm:border-t sm:border-white/10 lg:border-t-0' : ''}
          >
            <Link
              to={`/servicos/${slug}`}
              onClick={onLinkClick}
              className={clsx(
                'group flex items-baseline justify-between gap-4 transition-colors hover:bg-white/[0.04]',
                embedded ? 'py-3 pr-1' : 'px-4 py-5 sm:px-6 sm:py-6 lg:px-8'
              )}
            >
              <span className="flex min-w-0 items-baseline gap-2.5 sm:gap-4">
                <span
                  className={clsx(
                    'shrink-0 font-medium tabular-nums tracking-[0.1em] text-white/45',
                    embedded ? 'text-[10px]' : 'text-xs'
                  )}
                >
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span
                  className={clsx(
                    'font-heading font-semibold leading-snug text-white transition-colors group-hover:text-sky-300',
                    embedded ? 'text-[12px] leading-relaxed' : 'text-[14px] sm:text-[15px]'
                  )}
                >
                  {t(`servicesPage.fallback.${slug}.name`)}
                </span>
              </span>
              <PlusIcon
                className={clsx(
                  'shrink-0 text-white/55 transition-colors group-hover:text-white',
                  embedded ? 'h-3 w-3' : 'h-3.5 w-3.5'
                )}
                strokeWidth={1.5}
                aria-hidden
              />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
